import axios from "~/plugins/axios";

export default {
  paginate(page = 1, perPage = 10) {
    return axios.get("/web_api/v1/html_email_template", { params: { page, perPage } }).then((response) => response.data);
  },

  getHtmlEmailTemplateById(templateId) {
    return axios.get(`/web_api/v1/html_email_template/${templateId}`).then((response) => response.data);
  },

  delete(templateId) {
    return axios.delete(`/web_api/v1/html_email_template/${templateId}`).then((response) => response.data);
  },

  get(templateId) {
    return axios.get(`/web_api/v1/html_email_template/${templateId}`).then((response) => response.data);
  },

  update(template) {
    const url = `/web_api/v1/html_email_template/${template.id}`;
    return axios.put(url, template)
      .then((response) => response.data);
  },

  store(template) {
    const url = "/web_api/v1/html_email_template/";
    return axios.post(url, template)
      .then((response) => response.data);
  },

  sendExample(content, email) {
    const url = "/web_api/v1/html_email_template/send_test_mail";
    return axios.post(url, { content, email })
      .then((response) => response.data);
  },

  renderExample(template) {
    const url = "/web_api/v1/html_email_template/render";
    return axios.post(url, template)
      .then((response) => response.data);
  },
};
